var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMReports({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "currentColor",
    role: "img",
    "aria-label": "analytics report",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "analytics report") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.23,64.91a5.62,5.62,0,0,0,2.29-.49l53.11-24,8.26,18.3a5.58,5.58,0,0,0,10.18-4.59L307.51,30.76A5.58,5.58,0,0,0,300.12,28L241.93,54.24a5.58,5.58,0,0,0,2.3,10.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.61,411.69A5.59,5.59,0,0,0,433.7,415a5.47,5.47,0,0,0,2.29-.5L468.08,400a5.58,5.58,0,0,0,2.79-7.38l-33.6-74.43a5.59,5.59,0,0,0-10.18,4.6l31.31,69.33-27,12.19A5.59,5.59,0,0,0,428.61,411.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6,151.51,103.48,129a5.58,5.58,0,1,0-4.59-10.17l-55,24.82A5.56,5.56,0,0,0,41.13,151l59.46,131.71a5.58,5.58,0,0,0,10.18-4.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.44,478.94v-397a5.58,5.58,0,0,0-5.58-5.59H129.76a5.58,5.58,0,0,0-5.58,5.59v397a5.58,5.58,0,0,0,5.58,5.59h281.1A5.58,5.58,0,0,0,416.44,478.94Zm-11.16-5.58H135.34V87.51H405.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.16,292.71A77.82,77.82,0,0,0,345.89,215a5.58,5.58,0,0,0-5.58-5.58H273.74V142.82a5.58,5.58,0,0,0-5.58-5.58,77.74,77.74,0,1,0,0,155.47Zm-5.59-144.07V215a5.59,5.59,0,0,0,5.59,5.59H334.5a66.57,66.57,0,1,1-71.93-71.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.64,195.89h72.15a5.58,5.58,0,0,0,5.59-5.58,77.83,77.83,0,0,0-77.74-77.74,5.58,5.58,0,0,0-5.58,5.58v72.16A5.58,5.58,0,0,0,292.64,195.89ZM298.22,124A66.68,66.68,0,0,1,359,184.72H298.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,351.91H340.31a5.58,5.58,0,1,0,0-11.16H196a5.58,5.58,0,0,0,0,11.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.31,376.44H320.64a5.59,5.59,0,0,0,0,11.17h19.67a5.59,5.59,0,0,0,0-11.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,387.61h84.88a5.59,5.59,0,0,0,0-11.17H196a5.59,5.59,0,0,0,0,11.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.31,412.14H268.16a5.58,5.58,0,1,0,0,11.16h72.15a5.58,5.58,0,0,0,0-11.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,423.3h31.87a5.58,5.58,0,0,0,0-11.16H196a5.58,5.58,0,1,0,0,11.16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMReports);
export default __webpack_public_path__ + "static/media/m-reports.6a8c99de598eb13a7a643defb10b3d81.svg";
export { ForwardRef as ReactComponent };